import { render, staticRenderFns } from "./CategoryProportion.vue?vue&type=template&id=1f06af1c&scoped=true"
import script from "./CategoryProportion.vue?vue&type=script&lang=js"
export * from "./CategoryProportion.vue?vue&type=script&lang=js"
import style0 from "./CategoryProportion.vue?vue&type=style&index=0&id=1f06af1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06af1c",
  null
  
)

export default component.exports